import { Route } from '@angular/router';
import { mgsAuthenticatedGuard } from '../../mgs-guards';
import { PASSWORT_PATH } from '../../mgs-path-defs';

export const passwordAenderungRoute: Route = {
  path: PASSWORT_PATH,
  canActivate: [mgsAuthenticatedGuard],
  loadComponent: () => import('./passwort-aenderung.component')
};

export const passwortAenderungMitIdUndPasswortHashRoute: Route = {
  path: PASSWORT_PATH + '/:idUndPasswortHash',
  loadComponent: () => import('./passwort-aenderung.component')
};
